import React, { useState, useEffect } from 'react';
import {
  MainComponent,
  Texts,
  Component1,
  Component2,
  InnerComponent,
  Component4,
  Component3,
  HiddenComponent,
  FooterPart,
  HeaderPart,
} from '../style.js';
import InputSelect from 'src/components/shared/Form/Select/index.js';
import { useTheme } from '@emotion/react';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import theme, { palette, shadows } from 'src/config/theme.js';
import { alpha, Box } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { postTaskRequest, getStaffRequest } from '../../../store/appActions.js';
import DateTimePicker from 'src/components/App/DatePicker/index.js';
import storage from 'src/utils/storageUtils.js';
import ButtonComponent from 'src/components/shared/Button/index.js';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/images/add-square.svg';
import { getUserFromToken } from 'src/DecodeToken.js';
import { SaveButton } from '../style.js';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive.js';
import dayjs from 'dayjs';

const roleData = [
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
];

const validationSchema = Yup.object().shape({
  name: Yup.string().required('task name is required'),
  description: Yup.string().required('task description is required'),
  assigned: Yup.array()
    .min(1, 'Select at least one staff')
    .of(Yup.string().required())
    .required('Select at least one staff'),
  dueDate: Yup.date()
    .required('Select Due Date')
    .min(dayjs().startOf('day').toDate(), 'Due date cannot be in the past'),
});
function AddTask({ onClose, updateTask }) {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const theme = useTheme();

  const clinic = useSelector((state) => state.app.clinics);
  const clinicId = clinic.currentClinic.id;
  const dispatch = useDispatch();
  const [staffOptions, setStaffOptions] = useState([]);


  const handleSubmit = async (values, { resetForm }) => {
    const userId = getUserFromToken();
    console.log('my user id here', userId);
    if (!userId) {
      console('Failed to identify user. Please login again.', { variant: 'error' });
      return;
    }
    try {
      const taskData = {
        name: values.name,
        assigned: values.assigned,
        description: values.description,
        priority: values.priority,
        dueDate: values.dueDate,
        user: userId,
      };

      const response = await new Promise((resolve, reject) => {
        dispatch(postTaskRequest(taskData, resolve, reject));
      });
      console.log(`Staff created successfully ${response}`);

      updateTask();
      toast.success(response.message);

      resetForm();
      onClose();
    } catch (error) {
      console.log(error.message || 'Failed to add Staff', { variant: 'error' });
    }
  };

  useEffect(() => {
    const token = storage.get('TOKEN');
    const fetchData = async () => {
      const params = {
        clinicId: clinicId,
      };
      const response = await new Promise((resolve, reject) =>
        dispatch(getStaffRequest({ token, params }, resolve, reject))
      );

      if (response?.data) {
        const staffList = response.data;
        const options = staffList.map((staff) => ({
          label: staff.name,
          value: staff.email,
        }));

        setStaffOptions(options);
      }
    };

    fetchData();
  }, []);

  return (
    <Formik
      initialValues={{
        name: '',
        description: '',
        assigned: [],
        priority: 'high',
        dueDate: null,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
        <Form>
          <>
            <HeaderPart>
              Add Task
              <CloseIcon
                width={isMobile || isTablet ? 18 : 24}
                height={isMobile || isTablet ? 18 : 24}
                onClick={onClose}
                style={{ cursor: 'pointer' }} />
            </HeaderPart>
            <MainComponent>

              <Component2>
                <InnerComponent sx={{ width: '100%' }}>

                  <Texts>Task Title</Texts>
                  <InputComponent
                    name="name"
                    variant="outlined"
                    placeholder="Enter Task Name"
                    fullWidth
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    sx={{
                      backgroundColor: palette.gery.white,
                      boxShadow: shadows[1],
                      '& .MuiOutlinedInput-root': {
                        padding: '10px 0px',
                        borderRadius: '12px',
                        height: '52px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                      },
                      "& .MuiInputBase-input.MuiOutlinedInput-input": {
                        ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                      },
                    }}
                  />
                </InnerComponent>
              </Component2>
              <Component4>

                <Texts>Description</Texts>
                <InputComponent
                  name="description"
                  variant="outlined"
                  placeholder="Enter Task Description"
                  fullWidth
                  multiline
                  rows={4}
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.description && Boolean(errors.description)}
                  helperText={touched.description && errors.description}
                  sx={{
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[1],
                    '& .MuiOutlinedInput-root': {
                      padding: '16px 18px',
                      borderRadius: '12px',
                      height: '120px',
                      alignItems: 'flex-start',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                    },
                    "& .MuiInputBase-input.MuiOutlinedInput-input": {
                      ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                    },
                  }}
                />
              </Component4>
              <Component2>
                <InnerComponent sx={{ width: '100%' }}>
                  <Texts>Assigned To</Texts>
                  <InputSelect
                    name="assigned"
                    showNone={false}
                    options={staffOptions}
                    value={values.assigned}
                    multiple={true}
                    onChange={(value) => setFieldValue('assigned', value)}
                    onBlur={handleBlur}
                    error={touched.assigned && Boolean(errors.assigned)}
                    helperText={touched.assigned && errors.assigned}
                    variant="outlined"
                    placeholder="Select"
                    sx={{
                      // width: '200px',
                      boxShadow: theme.shadows[1],
                      '& .MuiOutlinedInput-root': {
                        height: '52px',
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '12px',
                      },
                    }}
                  />
                </InnerComponent>
              </Component2>

              <HiddenComponent>
                <InnerComponent>
                  <Texts>Priority</Texts>
                  <InputSelect
                    name="priority"
                    showNone={false}
                    options={roleData}
                    value={values.priority}
                    onChange={(value) => setFieldValue('priority', value)}
                    onBlur={handleBlur}
                    error={touched.priority && Boolean(errors.priority)}
                    helperText={touched.priority && errors.priority}
                    variant="outlined"
                    placeholder="Select"
                    sx={{
                      backgroundColor: palette.gery.white,
                      boxShadow: shadows[1],
                      '& .MuiOutlinedInput-root': {
                        padding: '10px 0px',
                        borderRadius: '12px',
                        height: '52px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                      },
                    }}
                  />
                </InnerComponent>
                <InnerComponent>
                  <Texts>Due Date</Texts>
                  <DateTimePicker
                    type="date"
                    name="dueDate"
                    // label="Date of Birth"
                    value={values.dueDate}
                    onChange={(val) => setFieldValue('dueDate', val)}
                    minDate={dayjs().startOf('day')}
                    onBlur={handleBlur}
                    error={touched.dueDate && Boolean(errors.dueDate)}
                    helperText={touched.dueDate && errors.dueDate}
                    sx={{
                      height: '52px',
                      borderRadius: '12px',
                      // padding: '10px 16px',
                    }}
                  />
                </InnerComponent>
              </HiddenComponent>
            </MainComponent>
            <FooterPart>
              <ButtonComponent
                variant="none"
                startIcon={<CloseIcon
                  width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                onClick={onClose}
              >
                Cancel
              </ButtonComponent>
              <SaveButton
                type="submit"
                variant="outlined"
                startIcon={<AddIcon
                  width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
              >
                Save
              </SaveButton>
            </FooterPart>
          </>
        </Form>
      )}
    </Formik>
  );
}

export default AddTask;
